var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFileImage = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 72 72",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66,14 L66,58 C66,59.1045695 65.1045695,60 64,60 L8,60 C6.8954305,60 6,59.1045695 6,58 L6,14 C6,12.8954305 6.8954305,12 8,12 L64,12 C65.1045695,12 66,12.8954305 66,14 Z M50,32 C47.790861,32 46,30.209139 46,28 C46,25.790861 47.790861,24 50,24 C52.209139,24 54,25.790861 54,28 C54,30.209139 52.209139,32 50,32 Z M12,36 L18.4728229,29.5271771 C19.2538715,28.7461285 20.5202014,28.7461285 21.30125,29.5271771 C21.3374451,29.5633722 21.3722372,29.6009434 21.4055497,29.6398079 L30.780538,40.5772943 C31.4664981,41.3775811 32.6558193,41.5081355 33.4990512,40.8757116 L38.6844092,36.9866931 C39.4488529,36.4133603 40.5120805,36.4608724 41.2223387,37.1001048 L60,54 L12,54 L12,36 Z M59,18 L13,18 C12.4477153,18 12,18.4477153 12,19 L12,54 L60,54 L60,19 C60,18.4477153 59.5522847,18 59,18 Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFileImage);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/file-image.552fee0b53b416675c064d268ef7a467.svg";